import {injectable} from 'inversify';

import {TextQuestionModel} from './TextQuestion.model';

@injectable()
export class TextQuestionFactory {
  create(props: TextQuestionModel.Props) {
    return new TextQuestionModel(props);
  }
}
